<template>
  <div class="xiaobu-container" v-closeSelect="'window'">
    <el-form ref="queryForm" :model="queryParams" :inline="true" class="search-form clearfix">
      <el-form-item class="search-field fl five-per-row" label="账单号" prop="operateNo">
        <el-input v-model.trim="queryParams.operateNo" placeholder="请输入账单号" clearable
          @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="客户/供应商" prop="customerName">
        <el-input v-model.trim="queryParams.customerName" placeholder="请输入客户/供应商" clearable
          @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="收付款类型" prop="payType">
        <el-select-dict dictType="PAY_TYPE" clearable placeholder="请选择收付款类型" v-model="queryParams.payType"
          @dictChange="handleQuery"></el-select-dict>
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="状态" prop="paymentStatus">
        <el-select-dict dictType="PAYMENT_STATUS" clearable placeholder="请选择状态" v-model="queryParams.paymentStatus"
          @dictChange="handleQuery"></el-select-dict>
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="创建时间" prop="beginTime">
        <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" @change="handleQuery"
          range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>

      <el-form-item class="fr">
        <el-button plain @click="resetQuery">重 置</el-button>
        <el-button type="primary" @click="handleQuery">查 询</el-button>
      </el-form-item>
    </el-form>
    <div class="table-wrap">
      <div class="table-control-box">
        <el-button v-hasPermission="['finance:bill:create']" type="primary" plain icon="el-icon-plus" size="mini"
          @click="handleAdd">新增</el-button>
      </div>
      <div class="table-box">
        <auto-height-table instanceHeight="358" ref="billTable" :class="{ empty: list.length === 0 }" empty-text=" "
          v-loading="loading" :data="list">
          <el-table-column label="账单号" prop="inventoryRecord.operateNo" align="center" min-width="168px">
            <template slot-scope="scope">
              <template v-if="scope.row.billNo">{{ scope.row.billNo }}</template>
              <el-link v-else-if="hasPermission(scope.row.inventoryRecord.operateNo)" type="primary"
                @click="handleDetail(scope.row.inventoryRecord.operateNo)">{{ scope.row.inventoryRecord.operateNo
                }}</el-link>
              <span v-else>{{ scope.row.inventoryRecord.operateNo }}</span>
            </template>
          </el-table-column>
          <el-table-column label="客户/供应商" prop="customer.customerName" align="center" min-width="128px" show-overflow-tooltip />
          <el-table-column label="资金金额(元)" prop="fundsAmount" align="center" min-width="108px" />
          <el-table-column label="已付款金额(元)" prop="paidAmount" align="center" min-width="128px" />
          <el-table-column label="已收款金额(元)" prop="receivedAmount" align="center" min-width="128px" />
          <el-table-column label="未结款金额(元)" prop="outstandingAmount" align="center" min-width="128px" >
              <template slot-scope="scope">
                {{ Math.abs(scope.row.outstandingAmount) }}
              </template>
          </el-table-column>
          <el-table-column-dict dictType="PAYMENT_STATUS" dictTypeNode="tag" label="状态" align="center"
            prop="paymentStatus" min-width="100px"></el-table-column-dict>
          <el-table-column label="盈利金额(元)" prop="profiAmount" align="center" min-width="108px" />
          <el-table-column-dict defaultVal="--" label="备注" prop="remark" align="center" show-overflow-tooltip min-width="108px" />
          <el-table-column label="创建时间" prop="createTime" align="center" show-overflow-tooltip width="168px" />
          <el-table-column v-if="
            mixinHasPermi([
              'finance:payRecord:list',
              'finance:payRecord:add',
            ])
          " label="操作" align="center" width="228px" fixed="right" class-name="small-padding ">
            <template slot-scope="scope">
              <el-button v-hasPermission="['finance:payRecord:list']" :type="Number(scope.row.fundsAmount) > 0 ? 'primary' : 'warning'" size="mini" :disabled="['3'].includes(scope.row.paymentStatus)" @click="handlePreviewPaidRecord(scope.row)">{{ Number(scope.row.fundsAmount)
                > 0 ? '收款记录' : '付款记录'}}</el-button>
              <el-button  v-hasPermission="['finance:payRecord:add']" :type="Number(scope.row.fundsAmount) > 0 ? 'success' : 'danger'" :disabled="['2', '3'].includes(scope.row.paymentStatus)" size="mini"
                @click="handleAddRecord(scope.row)">{{ Number(scope.row.fundsAmount) > 0 ? '收款' : '付款' }}</el-button>
            </template>
          </el-table-column>
        </auto-height-table>

        <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize" @pagination="getList" />
      </div>
    </div>
    <div class="total-box flex-c-s">
      <div class="money-info flex-grow flex-c-s">
        <div class="label flex-shrink">合计账单金额：</div>
        <div calss="value">{{ totalFundsAmount }}元</div>
      </div>
      <div class="money-info flex-grow flex-c-s">
        <div class="label flex-shrink">合计已付款金额：</div>
        <div calss="value">{{ totalPaidAmount }}元</div>
      </div>
      <div class="money-info flex-grow  flex-c-s">
        <div class="label flex-shrink">合计已收款金额：</div>
        <div calss="value">{{ totalReceivedAmount }}元</div>
      </div>
      <div class="money-info flex-grow flex-c-s">
        <div class="label flex-shrink">合计未结款金额：</div>
        <div calss="value">{{ totalOutstandingAmount }}元</div>
      </div>
      <div class="money-info flex-grow flex-c-s">
        <div class="label flex-shrink">合计利润金额：</div>
        <div calss="value">{{ totalProfiAmount }}元</div>
      </div>
    </div>

    <!-- 添加或编辑对话框 -->
    <add-pay-record ref="addPaidRecord" :title="addRecordTitle" :visible.sync="openAddRecord"
      :modal-append-to-body="false" :close-on-click-modal="false" :baseForm="baseForm" @close="openAddRecord = false"
      @successs="getList" width="1024px"></add-pay-record>

    <pay-record ref="paidRecord" :type="type" :title="recordTitle" :visible.sync="openRecord"
      :modal-append-to-body="false" :close-on-click-modal="false" @closeRecord="openRecord = false" @successs="getList"
      width="1280px"></pay-record>

    <add-bill ref="addBillRef" title="新增账单" :visible.sync="showAddBill" :modal-append-to-body="false" :close-on-click-modal="false"
     @close="showAddBill = false" @successs="getList" width="880px"></add-bill>
  </div>
</template>

<script>
import { billApi } from "@/api"
import addPayRecord from "./components/add-pay-record.vue"
import addBill from "./components/add-bill.vue"
import payRecord from "./components/pay-record.vue"
export default {
  name: "financeBillManage",
  components: {
    addPayRecord,
    payRecord,
    addBill
  },
  data() {
    return {
      showAddBill: false,
      type: "pay",
      addRecordTitle: "", // 新增付款记录标题
      openAddRecord: false, // 打开添加付款记录弹框
      recordTitle: "付款记录",
      openRecord: false, // 打开付款记录
      totalFundsAmount: 0,
      totalPaidAmount: 0,
      totalReceivedAmount: 0,
      totalOutstandingAmount: 0,
      totalProfiAmount: 0,
      //搜索条件参数
      queryParams: {
        customerName: "", // 客户名称
        operateNo: "", // 账单号
        payType: "", // 收付款类型
        paymentStatus: "", // 状态
        beginTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 10
      },
      dateRange: [],
      list: [],

      loading: false,
      total: 0,

      // 表单参数
      baseForm: {
        receivedCustomerName: "", //收款人姓名
        receivedCustomerId: "", // 收款人id
        payCustomerName: "", // 付款人姓名
        payCustomerId: "", // 付款人id
        outstandingAmount: "", // 当前未结款金额
        payTime: "", // 付款时间
        payWay: "", // 付款方式
        payAmount: "", // 付款金额
        payScreenshotList: [], // 付款截图
        payScreenshot: "", // 付款截图 因为逗号隔开
        remark: "" // 备注
      }
    }
  },
  watch: {
    openAddRecord(val) {
      if (!val) {
        this.baseForm = {
          receivedCustomerName: "", //收款人姓名
          receivedCustomerId: "", // 收款人id
          payCustomerName: "", // 付款人姓名
          payCustomerId: "", // 付款人id
          outstandingAmount: "", // 当前未结款金额
          payTime: "", // 付款时间
          payWay: "", // 付款方式
          payAmount: "", // 付款金额
          payScreenshotList: [], // 付款截图
          payScreenshot: "", // 付款截图 因为逗号隔开
          remark: "" // 备注
        }
        this.$refs.addPaidRecord && this.$refs.addPaidRecord.resetForm()
      }
    }
  },
  created() {
    //获取列表
    this.getList()
  },
  methods: {
    handleAdd() {
      this.$refs.addBillRef.resetForm()
      this.showAddBill = true
    },
    // 打开新增付款记录弹框
    handleAddRecord(row) {
      if (row.fundsAmount > 0) {
        this.addRecordTitle = `新增收款记录(${row.billNo || row.inventoryRecord.operateNo})`
        this.type = "received"
      } else {
        this.addRecordTitle = `新增付款记录(${row.billNo || row.inventoryRecord.operateNo})`
        this.type = "pay"
      }
      this.baseForm = JSON.parse(JSON.stringify(row))
      // 修复会报customer字段问题
      this.baseForm.customerName = row.customer.customerName
      this.baseForm.remark = ""
      
      // 修复付款时间和付款方式会爆红的bug
      this.baseForm.payTime = ""
      this.baseForm.payWay = ""
      this.openAddRecord = true
    },
    // 查看付款记录
    handlePreviewPaidRecord(row) {
      if (row.fundsAmount > 0) {
        this.recordTitle = `收款记录(${row.billNo || row.inventoryRecord.operateNo})`
      } else {
        this.recordTitle = `付款记录(${row.billNo || row.inventoryRecord.operateNo})`
      }
      this.openRecord = true
      // 获取付款记录
      this.$refs.paidRecord.getList(Number(row.billId))
    },
    // 判断是否有对应权限
    hasPermission(operateNo) {
      const type = operateNo.substr(0, 2)
      const obj = {
        "RK": ["inventory:entry:list"],
        "CK": ["inventory:out:list"],
        "YK": ["inventory:move:list"],
        "PK": ["inventory:check:list"]
      }
      return this.mixinHasPermi(obj[type] || [])
    },
    // 前往查询单号
    handleDetail(operateNo) {
      const type = operateNo.substr(0, 2)
      const nameObj = {
        "RK": "inventoryEntryManage",
        "CK": "inventoryOutManage",
        "YK": "inventoryMoveManage",
        "PK": "inventoryCheckManage"
      }
      this.$router.push({
        name: nameObj[type],
        query: {
          operateNo
        }
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = []
      this.mixinResetForm("queryForm")
      this.handleQuery()
    },
    /** 查询角色列表 */
    getList() {
      this.loading = true
      billApi
        .getList(this.mixinAddDateRange(this.queryParams, this.dateRange))
        .then((response) => {
          this.list = response.rows
          this.total = response.total
          this.totalFundsAmount = response.totalFundsAmount
          this.totalPaidAmount = response.totalPaidAmount
          this.totalReceivedAmount = response.totalReceivedAmount
          this.totalOutstandingAmount = response.totalOutstandingAmount
          this.totalProfiAmount = response.totalProfiAmount
          this.loading = false
        })
        .catch((err) => {
          if (err?.name === "CanceledError") {
            return
          }
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.total-box {
  padding: 12px;
  font-size: 14px;
  background: #fff;
  border-radius: 4px;
  margin-top: 12px;

  .money-info {
    padding: 12px;
  }
}
</style>